import { createContext, useContext, ReactNode, useCallback, useMemo } from 'react';

import { IS_TENANT_MODE } from '../config/tenantMode';
import { useSseConnection, SmsCodeData, ConnectionState } from '../hooks/useSseConnection';

interface SseContextValue {
  connectionState: ConnectionState;
  receivedCodes: Map<string, SmsCodeData>;
  connect: () => void;
  disconnect: () => void;
  getCodeForNumber: (temporaryNumberId: string) => SmsCodeData | undefined;
  isConnected: boolean;
  isConnecting: boolean;
}

const SseContext = createContext<SseContextValue | undefined>(undefined);

interface SseContextProviderProps {
  children: ReactNode;
  autoConnect?: boolean;
}

export function SseContextProvider({ children, autoConnect = true }: SseContextProviderProps) {
  const onCodeReceived = useCallback((data: SmsCodeData) => {
    console.log('SSE: Code received', data);
  }, []);

  const isLoggedIn = useMemo(() => {
    try {
      const raw = localStorage.getItem('user');
      if (!raw) return false;
      const parsed = JSON.parse(raw);
      return !!(parsed?._id || parsed?.userId);
    } catch {
      return false;
    }
  }, []);

  const sseConnection = useSseConnection({
    autoConnect: autoConnect && isLoggedIn && !IS_TENANT_MODE,
    onCodeReceived,
  });

  return <SseContext.Provider value={sseConnection}>{children}</SseContext.Provider>;
}

export function useSse(): SseContextValue {
  const context = useContext(SseContext);
  if (context === undefined) {
    throw new Error('useSse must be used within a SseContextProvider');
  }
  return context;
}

